import React from 'react';
import PropTypes from 'prop-types';

export default class TableSort extends React.Component {

    render() {
        const {
            id,
            asc,
            label,
            style,
            onSort,
            selected,
            className,
        } = this.props;

        return (
            <div
                className={className}
                onClick={() => onSort(id)}
                style={{
                    color: selected ? '#555555' : undefined,
                    cursor: 'pointer',
                    ...style
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexFlow: 'row nowrap',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                    }}
                >
                    {label}
                    <i
                        className="material-icons"
                        children={asc ? 'expand_less' : 'expand_more'}
                        style={{
                            fontWeight: 'bold',
                            fontSize: 15,
                            marginLeft: 5,
                        }}
                    />
                </div>
            </div>
        );
    }

}

TableSort.propTypes = {
    id: PropTypes.string.isRequired,
    asc: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    style: PropTypes.object,
    selected: PropTypes.bool,
    className: PropTypes.string,
    onSort: PropTypes.func.isRequired,
};




// WEBPACK FOOTER //
// ./src/app/shared/components/TableSort.js